<template>
 <v-card flat color="rgb(81, 167, 248, .1)" height="74" width="200">
    <v-card-text class="d-flex align-center">
          <v-avatar rounded color="white">
            <v-icon color="titleText"> mdi-chart-line </v-icon>
          </v-avatar>
          <div class="ml-3">
            <h4 class="darkGrey--text">ADJ-R<sup>2</sup></h4>
            <h3 class="blue--text">
              {{ this.AdjustedRsquared }}%
            </h3>
          </div>
    </v-card-text>
  </v-card>
</template>

<script>


export default ({
   props: {
    divdata: [],
  },
  data: () => ({
    AdjustedRsquared: "",
     tempctrldata: [],
  }),
  methods: {
        getdivtext() {
      this.Rsquared = 0;
      let temp = [];
      temp = this.tempctrldata;
       this.AdjustedRsquared=  temp.filter((a) => a.region == "national")[0].adj_rsquared;
    },
  
  },
  mounted() {
    this.tempctrldata = this.divdata;
   this.getdivtext();
  },
    watch: {
    divdata: function (val) {
     // alert("Onoad -" + val);
      if (val) {
        this.tempctrldata = this.divdata;
       this.getdivtext();
      }
    },
  },
});
</script>

<style scoped>
.headerbox {
  font-weight: bold;
  font-style: italic;
  font-size: 20px;
  color: gray;
}

.headerboxtitle {
  font-size: 20px;
  color: gray;
  text-align: center;
  font-style: italic;
  font-weight: bold;
}

.card2 {
  background-color: #28a745;
}
</style>
